import { PBXCallFlowTreatments } from "../pbx_treatments/pbx_call_flow_treatments";
import { TreatmentsManager } from "./treatments_manager";
import { TreatmentTarget } from "./treatment_target";

export class CallTreatmentsList extends HTMLElement {
  constructor(domain_id, treatment_type=null, group_id) {
    super();
    this.domain_id = domain_id ? domain_id : document.querySelector("#object_id").value;
    this.treatment_type = treatment_type;
    this.group_id = group_id;
  }

  connectedCallback() {
    this.innerHTML =
      `
      <style>
        #ct_create_treatment {
          margin-bottom: 20px;
        }
      </style>

      <div id="call_treatments_list">
        <h3 class="pull-left">${this.treatment_type ? 'Call Flow ' : ''}Treatment Management</h3>
        <a class="btn btn-primary pull-right" id="ct_create_treatment">Create ${this.treatment_type ? 'Call Flow ' : ''}Treatment</a>
        <table id="call_treatments_table" class='table' style="margin-top:15px; width: 100%">
          <thead>
            <tr>
              <th>${this.treatment_type ? 'Call Flow ' : ''}Treatment Name</th>
              <th>Type</th>
              <th>In use</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>


        <div class="col-sm-12" id="call_treatment_path" style="display:none;">
          
        </div>  

        <div id="treatment2_0">
      </div>
      `;

    TreatmentsManager.init(this.domain_id);
    let treatment = this.treatment_type ? document.createElement(`${this.treatment_type}-call-treatment`) : document.createElement('create-treatment');
    if(this.treatment_type == 'pbx') {
      treatment = new PBXCallFlowTreatments(this.domain_id, this.group_id)
    }
    this.querySelector("#call_treatment_path").appendChild(treatment);
  }
}

customElements.define('call-treatments-list', CallTreatmentsList)